import { render, staticRenderFns } from "./ChatroomList.vue?vue&type=template&id=17945077&scoped=true&"
import script from "./ChatroomList.vue?vue&type=script&lang=js&"
export * from "./ChatroomList.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomList.vue?vue&type=style&index=0&id=17945077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17945077",
  null
  
)

export default component.exports